import { PanelColorSettings } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

export default function ColorSettings({
  title,
  textColor,
  backgroundColor,
  handleUpdateColorValue,
}) {
  return (
    <PanelColorSettings
      title={title}
      initialOpen={false}
      enableAlpha={true}
      colorSettings={[
        {
          value: backgroundColor,
          onChange: (newColor) =>
            handleUpdateColorValue("backgroundColor", newColor),
          clearable: true,
          label: __("Background color", "brandy-blocks"),
        },
        {
          value: textColor,
          onChange: (newColor) => handleUpdateColorValue("textColor", newColor),
          clearable: true,
          label: __("Text color", "brandy-blocks"),
        },
      ]}
    />
  );
}
